/** The fallback used when the browser gives no zone. Not a business choice:
 *  it is the one value `isSupportedTimeZone` always accepts, so a request
 *  never fails validation just because Intl returned nothing. */
export const VIEWER_TIME_ZONE_FALLBACK = "UTC";

/** The viewer's own current IANA timezone, read from the browser at call
 *  time. Q271: every fan-facing game date and start time is converted to the
 *  zone the fan is viewing from, and it moves with them. There is no
 *  platform display zone and no per-fan timezone setting -- the `timezone`
 *  field on the profile record is NOT read here. */
export function resolveViewerTimeZone(): string {
  try {
    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return zone === "" ? VIEWER_TIME_ZONE_FALLBACK : zone;
  } catch {
    return VIEWER_TIME_ZONE_FALLBACK;
  }
}
